<template>
  <div>
    <div>
      <HeaderOfPage :bgSrc="'single-town-place.jpeg'" :theDiscription="'بيروت وهي مدينة تقع في اقصى غرب اسيا'" :titleOfPage="'بيروت'"/>
    </div>
    <div class="pages-container">
      <b-container>
        <b-row>
          <b-col sm="3" v-for="tour in 4" :key="tour+'s'">
            <SingleTours :stars="4"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="3" v-for="tour in LoadingNumber" :key="tour+'l'">
            <TourLoading/>
          </b-col>
        </b-row>
        <b-row>
          <div class="see-more">
             <b-button variant="primary" @click="LoadingNumber = 4">المزيد</b-button>
          </div>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage from '../global/HeaderOfPage'
  import SingleTours  from '../global/SingleTours'
  import TourLoading  from '../lazyLoading/TourLoading'
  export default {
    name: 'PlaceSearch',
    components: {
      HeaderOfPage,
      SingleTours,
      TourLoading
    },
    data() {
      return {
        LoadingNumber:0
      }
    }
  }
</script>
